export default function About() {
  return (
    <section className="tab-panel active">
      <div className="page-head">
        <div>
          <h1 className="page-title">
            About Oraczen <span className="page-pill">PLATFORM</span>
          </h1>
          <p className="page-sub">
            Oraczen builds the agentic AI platform behind the Cashflow Sentinel insight engine.
            The Zen Insights tab (under Tools) is one expression of that platform applied to
            construction-finance decision support.
          </p>
        </div>
        <div className="page-controls">
          <a className="btn-ghost" href="https://www.oraczen.ai/" target="_blank" rel="noreferrer">
            Visit oraczen.ai ↗
          </a>
        </div>
      </div>

      <div className="about-hero">
        <div className="about-hero-eyebrow">Tagline</div>
        <h2 className="about-hero-title">Rewiring enterprises with agentic systems</h2>
        <p className="about-hero-sub">
          Oraczen builds agentic AI solutions that move enterprises from complexity to clarity —
          automating workflows and transforming business processes through orchestrated AI agents.
        </p>
      </div>

      <div className="about-grid">
        <article className="about-card">
          <div className="about-card-eyebrow">Platform</div>
          <h3 className="about-card-title">Zen Platform</h3>
          <p className="about-card-body">
            The core orchestration platform. Provides observability across agent execution,
            conversations, and pipeline steps — giving operators the ability to troubleshoot,
            optimise, and monitor agent performance in production.
          </p>
        </article>

        <article className="about-card">
          <div className="about-card-eyebrow">Product</div>
          <h3 className="about-card-title">Auron</h3>
          <p className="about-card-body">
            Agentic engagement platform for sales and customer conversations. Captures and
            transforms dialogue into organisational memory — context that informs future
            decisions across the enterprise.
          </p>
        </article>

        <article className="about-card">
          <div className="about-card-eyebrow">Product</div>
          <h3 className="about-card-title">Scorpio</h3>
          <p className="about-card-body">
            Agentic supply chain platform for procurement optimisation. Provides visibility
            across spend, contract, category, and supplier data — typically delivering ~10%
            annual procurement savings on deployment.
          </p>
        </article>

        <article className="about-card">
          <div className="about-card-eyebrow">Observability</div>
          <h3 className="about-card-title">Observezen</h3>
          <p className="about-card-body">
            Deep visibility into agent deployments. Tracks the execution of every agent, every
            conversation, every pipeline step — so production AI is auditable, debuggable, and
            improvable rather than a black box.
          </p>
        </article>
      </div>

      <section className="about-block">
        <h2 className="about-block-title">Capabilities</h2>
        <ul className="about-bullets">
          <li>Capture and transform sales and customer conversations into organisational memory</li>
          <li>Visibility into agent execution, conversations, and pipeline steps</li>
          <li>Supply chain visibility across spend, contract, category, and supplier data</li>
          <li>Troubleshooting, optimisation, and performance monitoring for agents in production</li>
          <li>Orchestration across multi-agent workflows with handoff and escalation patterns</li>
        </ul>
      </section>

      <section className="about-block">
        <h2 className="about-block-title">Differentiators</h2>
        <ul className="about-bullets">
          <li>Thought leadership in AI orchestration and agent building</li>
          <li>Observezen delivers deep visibility into agent deployments — no black-box deployments</li>
          <li>Procurement savings of approximately 10% annually on Scorpio deployments</li>
          <li>Enterprise-grade: production observability is core, not an afterthought</li>
        </ul>
      </section>

      <section className="about-block">
        <h2 className="about-block-title">Customers</h2>
        <p className="about-customers-lead">Enterprises shipping with Oraczen include:</p>
        <div className="about-customers">
          {[
            "Unilever",
            "Thermo Fisher Scientific",
            "Rosy Blue",
            "Valorant",
            "Handelsbanken",
            "Ingredion",
            "QSC",
            "Genie",
            "Mythri Movie",
          ].map((c) => (
            <span key={c} className="about-customer-chip">{c}</span>
          ))}
        </div>
      </section>

      <section className="about-block">
        <h2 className="about-block-title">In this dashboard</h2>
        <p>
          The <strong>Zen Insights</strong> tab (under Tools in the sidebar) is an applied instance
          of the Zen platform: a deterministic, citation-grounded brief generator that synthesises findings
          across Portfolio Billing, AR &amp; Customer Risk, Net Income Forecast, and Customer 360.
          Every claim cites the KPI codes it derives from. The findings flagged "hidden gem" are
          patterns visible only when joining cards across tabs.
        </p>
        <p className="about-block-foot muted">
          Production deployments connect to live D365 → Synapse Link feeds and route the brief
          through Oraczen's agent orchestration with full observability via Observezen.
        </p>
      </section>

      <section className="about-block about-cta">
        <h2 className="about-block-title">Get in touch</h2>
        <p>
          Talk to Orac, or reach the team via{" "}
          <a href="https://www.oraczen.ai/contact" target="_blank" rel="noreferrer">
            oraczen.ai/contact
          </a>.
        </p>
      </section>
    </section>
  );
}
